function About() {
    return (
      <div className="container py-16">
        <h1 className="text-4xl font-bold mb-8">Nosotros</h1>
        <p className="text-lg">Contenido de la página Nosotros...</p>
      </div>
    );
  }
  
  export default About;